window.FacebookPromNight ?= {}

FacebookPromNight.init = (payload, done) ->
  $ ->
    $(".share-links .icon-facebook").on click: (e) ->
      e.preventDefault()
      window.open('https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent($(this).attr('href')), '_blank', 'width=626,height=436')

    done()


module.exports = FacebookPromNight
